import React from 'react'
import { Button, Form, Input, Modal, Space, message } from 'antd'
import { createAdminPoll, updateAdminPoll } from '../../../../features/poll/api-admin'

const { TextArea } = Input

interface QuizModalProps {
  open: boolean
  quiz: any
  onCancel: () => void
  onOk: () => void
}

export default function QuizModal({ open, quiz, onCancel, onOk }: QuizModalProps) {
  const [form] = Form.useForm()
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    if (open) {
      form.setFieldsValue({
        title: quiz?.title || '',
        description: quiz?.description || '',
      })
    }
  }, [open, quiz, form])

  const handleSave = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()

      if (quiz?.id) {
        await updateAdminPoll(quiz.id, values)
        message.success('Опросник обновлён')
      } else {
        await createAdminPoll(values)
        message.success('Опросник создан')
      }

      onOk()
    } catch (e: any) {
      message.error(e?.message || 'Не удалось сохранить опрос')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={quiz ? 'Редактировать опрос' : 'Создать опрос'}
      open={open}
      onOk={handleSave}
      onCancel={onCancel}
      confirmLoading={loading}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item name="title" label="Название" rules={[{ required: true }]}>
          <Input placeholder="Введите название опроса" />
        </Form.Item>
        <Form.Item name="description" label="Описание">
          <TextArea rows={3} placeholder="Введите описание опроса" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
